import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../utils/translations';
import Experiment, {Off, On} from '@homeaway/react-experiment';
import PriceDetails, {PriceDetailsNew} from '@homeaway/react-price-details';
import StayContext from '../context/StayContext';
import {SystemConsumer} from '../context/SystemContext';
import {BURN_DISCOUNT} from '../constants';
import {
    PRICE_DETAILS_LOCATION,
    PRICE_DETAILS_LOCATION_MWEB,
    PRICE_DETAILS_NEW_LOCATION,
    PRICE_DETAILS_NEW_LOCATION_MWEB,
} from '../../utils/EDAP/PriceDetailsWrapper';

import {getReservationUuidFromStayContextData} from '../../utils/stayDomain.js';

export class PriceDetailsWrapper extends React.Component {
    static propTypes = {
        actionLocation: PropTypes.string,
        isBookingModified: PropTypes.bool,
        isVrboIpmStaticMessaging: PropTypes.bool,
        priceDetails: PropTypes.shape({}),
        shouldShowModifiedPayments: PropTypes.bool,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        translations: {},
    };

    static contextType = StayContext;

    get stayContext() {
        if (!this.context) {
            throw new Error(
                'stayContext must be used within a StayContextProvider'
            );
        }
        return this.context;
    }

    render() {
        const {
            isVrboIpmStaticMessaging,
            isBookingModified,
            priceDetails,
            shouldShowModifiedPayments,
            translations,
        } = this.props;
        const reservationUuid = getReservationUuidFromStayContextData(
            this.stayContext
        );
        const {
            stay: {
                unit: {integratedPropertyManager},
            },
        } = this.stayContext;

        if (!priceDetails) {
            return null;
        }
        const shouldShowLoyalty =
            priceDetails?.lineItems &&
            priceDetails.lineItems
                .map((lineItem) => lineItem.type)
                .includes(BURN_DISCOUNT) &&
            priceDetails?.loyalty;

        const payments =
            (shouldShowLoyalty
                ? priceDetails.loyalty.paymentsWithBurn
                : priceDetails.payments) || [];

        const vas = priceDetails.vasItems || [];
        let combinedPayments = payments.concat(vas);
        if (
            shouldShowModifiedPayments &&
            isVrboIpmStaticMessaging &&
            isBookingModified &&
            integratedPropertyManager
        ) {
            combinedPayments = combinedPayments.filter(
                (item) => item.status === 'PAID'
            );
        }
        const edapPayNowData = `{"action_location": "${this.props.actionLocation}", "reservation_id": "${reservationUuid}"}`;

        const priceDetailsData = {
            edapEventJson: priceDetails.edapEventJson,
            edapPayNowJson: edapPayNowData,
            lineItems: priceDetails.lineItems,
            notes: priceDetails.notes,
            oneKeyCashUsed: shouldShowLoyalty ? true : false,
            payments: combinedPayments,
            totals:
                shouldShowLoyalty && priceDetails?.loyalty?.totalsWithBurn
                    ? priceDetails.loyalty.totalsWithBurn
                    : priceDetails.totals,
            translations: {
                payText: translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.inbox.conversation.buttons.pay'
                ),
                title: translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.inbox.conversation.quoteSummary.title'
                ),
            },
        };
        return (
            <SystemConsumer>
                {({system}) => {
                    const {isDesktop} = system;
                    return (
                        <div className="PriceDetailsWrapper">
                            {!isDesktop && (
                                <Experiment
                                    name={
                                        'pdp_price_transparency_redesign_mweb'
                                    }
                                >
                                    <On>
                                        <PriceDetailsNew
                                            {...priceDetailsData}
                                            actionLocation={
                                                PRICE_DETAILS_NEW_LOCATION_MWEB
                                            }
                                        />
                                    </On>
                                    <Off>
                                        <PriceDetails
                                            {...priceDetailsData}
                                            actionLocation={
                                                PRICE_DETAILS_LOCATION_MWEB
                                            }
                                        />
                                    </Off>
                                </Experiment>
                            )}
                            {isDesktop && (
                                <Experiment
                                    name={'vrbo_pdp_pricetransparency_desktop'}
                                >
                                    <On>
                                        <PriceDetailsNew
                                            {...priceDetailsData}
                                            actionLocation={
                                                PRICE_DETAILS_NEW_LOCATION
                                            }
                                        />
                                    </On>
                                    <Off>
                                        <PriceDetails
                                            {...priceDetailsData}
                                            actionLocation={
                                                PRICE_DETAILS_LOCATION
                                            }
                                        />
                                    </Off>
                                </Experiment>
                            )}
                        </div>
                    );
                }}
            </SystemConsumer>
        );
    }
}
